<template>
  <div class="content-time-filter-container">
    <v-select
      class="content-time-filter-control"
      :items="timeSpans"
      item-text="display"
      item-value="value"
      v-model="selectedTime"
      :placeholder="controlLabel"
      outlined
      return-object
    ></v-select>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashDebounce from "lodash/debounce";
import { mapGetters } from "vuex";
import { MODULE_PREFIX_USER, MODULE_PREFIX_HOME } from "@/store";
import { SAVE_PREFERENCES } from "@/store/actions.type";

const DEFAULT_SELECTED = 30;
const TIME_SPANS_BETTER = [
  { value: 1, display: "24 Hours" },
  { value: 7, display: "7 Days" },
  { value: 30, display: "30 Days" },
  { value: 60, display: "60 Days" },
];

export default {
  name: "ContentTimeFilter",
  props: {
    value: {
      type: Number,
    },
  },
  created() {
    this.getPrefs();
  },
  data() {
    return {
      timeSpans: TIME_SPANS_BETTER,
      selectedTime: DEFAULT_SELECTED,
    };
  },
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    controlLabel() {
      return this.timeFilter ? "Time Frame" : "";
    },
  },
  methods: {
    async savePrefs() {
      if (this.preferences.alerts && this.preferences.alerts.content) {
        this.preferences.alerts.content.timeFilter = this.selectedTime.value;
        await this.$store.dispatch(
          MODULE_PREFIX_USER + SAVE_PREFERENCES,
          this.preferences
        );
      }
    },
    getPrefs() {
      this.selectedTime =
        lodashGet(this.preferences, "alerts.content.timeFilter") ||
        DEFAULT_SELECTED;
    },
  },
  watch: {
    selectedTime: lodashDebounce(function () {
      this.savePrefs();
    }, 500),
  },
};
</script>
<style scoped>
.content-time-filter-container {
  width: 125px;
  padding: 5px 5px 0 0;
}

.content-time-filter-control >>> .v-input__slot {
  border-radius: 10px;
  min-height: auto;
}

.content-time-filter-control >>> .v-label {
  top: auto;
  color: #646464;
}

.content-time-filter-control >>> .v-input__append-inner {
  display: none;
}

.content-time-filter-control >>> .v-select__selections {
  padding: 0 !important;
}
</style>
